import React from "react";
import { Link } from "react-router-dom";
import shelf from "../assets/shelf.png";
import birds from "../assets/birds.png";
import butterfly from "../assets/butterfly.png";
import sun from "../assets/sun.png";
import cloud from "../assets/cloud.png";
import emilycollage from "../assets/emilycollage.png";
import flowerscollage from "../assets/flowerscollage.png";
import sticker from "../assets/sticker.png";
import "./error.css";

const ErrorPage = () => {
  return (
    <main className="error_page">
      <div className="error_page_backdrop" aria-hidden="true">
        <div className="error_collage_stage">
          <img src={shelf} className="error_collage_shelf" alt="" />
          <img src={birds} className="error_collage_birds" alt="" />
          <img src={butterfly} className="error_collage_butterfly" alt="" />
          <img src={sun} className="error_collage_sun" alt="" />
          <img src={cloud} className="error_collage_cloud" alt="" />
          <img src={emilycollage} className="error_collage_emily" alt="" />
          <img src={flowerscollage} className="error_collage_flowers" alt="" />

          <div className="error_collage_note_wrap">
            <img src={sticker} className="error_collage_sticker" alt="" />
            <p className="error_collage_note">
              The collage represents Dickinson&apos;s inner world, where nature symbolizes emotion, transformation, and the imagination she nurtured within confinement.
            </p>
          </div>
        </div>
      </div>

      <div className="error_page_panel">
        <p className="error_page_code">404</p>
        <h1 className="error_page_title">This page is not part of the archive.</h1>
        <p className="error_page_text">
          The path you opened does not exist. Use the header links to return to the story.
        </p>
        <Link className="error_page_link" to="/">
          Return Home
        </Link>
      </div>
    </main>
  );
};

export default ErrorPage;
